export function addShowMoreDescriptionBtn() {
    $('.show-more-description-btn').remove();
    if ($('#list-description').height() > $('.description-container').height()) {
        $('.description-container').append(
            "<div class='show-more-description-btn'><span class='ellipsis'>... </span><span class='plus'><i class='glyphicon glyphicon-plus'></i></span></div>"
        );
    }
}

export function showMoreDescription(element) {
    var parent = $(element).parents('.description-container').first() || null;
    if (parent.length) {
        if (parent.hasClass('seo')) {
            $(element).addClass('opened');
            $(element).find('span.plus i').addClass('glyphicon-chevron-up');
            parent.removeClass('seo');
        } else {
            $(element).removeClass('opened')
            $(element).find('span.plus i').removeClass('glyphicon-chevron-up');
            parent.addClass('seo');
        }
    } else {
        $('.show-more-description-btn').remove();
        $('.description-container').removeClass('description-container');
    }
}
